import React from "react";

export const SocialMediaLinkedin = ({ className }) => {
  return (
    <svg
      className={`social-media-linkedin ${className}`}
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="path"
        d="M21 18.5C21 19.881 19.881 21 18.5 21H5.5C4.1195 21 3 19.881 3 18.5V5.5C3 4.119 4.1195 3 5.5 3H18.5C19.881 3 21 4.119 21 5.5V18.5Z"
        fill="#0A66C2"
      />

      <path
        className="path"
        d="M6 9.5H8.5V18H6V9.5ZM7.2425 8.5H7.2285C6.4825 8.5 6 7.944 6 7.2495C6 6.54 6.4975 6 7.257 6C8.0175 6 8.486 6.54 8.5 7.2495C8.5 7.9435 8.0175 8.5 7.2425 8.5ZM18 18H15.5V13.4505C15.5 12.3515 14.8875 11.6015 13.904 11.6015C13.1535 11.6015 12.7475 12.1075 12.5505 12.5965C12.4785 12.7715 12.5 13.2555 12.5 13.5V18H10V9.5H12.5V10.808C12.8605 10.25 13.425 9.5 14.869 9.5C16.658 9.5 17.9995 10.625 17.9995 13.137L18 18Z"
        fill="white"
      />
    </svg>
  );
};
